import { render, staticRenderFns } from "./number_rule.vue?vue&type=template&id=7ac237c2&scoped=true"
import script from "./number_rule.vue?vue&type=script&lang=js"
export * from "./number_rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac237c2",
  null
  
)

export default component.exports